import { render, staticRenderFns } from "./SessionSoundsSettings.vue?vue&type=template&id=7ead863e"
import script from "./SessionSoundsSettings.vue?vue&type=script&lang=ts"
export * from "./SessionSoundsSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports